module.exports = __webpack_public_path__ + "media/images/IMG_0008-30-bc6ba84842bc421a7c8ffc1326d9e907.jpg";